import { render, staticRenderFns } from "./SearchPanel.vue?vue&type=template&id=194a89b4&scoped=true&"
import script from "./SearchPanel.vue?vue&type=script&lang=js&"
export * from "./SearchPanel.vue?vue&type=script&lang=js&"
import style0 from "./SearchPanel.vue?vue&type=style&index=0&id=194a89b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194a89b4",
  null
  
)

export default component.exports